export default {
    '保存成功':'保存成功',
    '总日程表':'總日程表',
    '日程明细表':'日程明細表',
    '单项日程明细表':'單項日程明細表',
    '报名列表':'報名列表',
    '第':'第',
    '组':'組',
    '编排成功':'編排成功',
    '分组成功':'分組成功',
    '取消编排':'取消編排',
    '取消编排成功':'取消編排成功',
    '配置成功':'配置成功',
    '编排列表':'編排列表',
    '运动会积分列表':'運動會積分列表',
    '运动会明细列表':'運動會明細列表',
    '记录管理列表':'記錄管理列表',
    '记录导入模板':'記錄導入模板',
    '结束成功':'結束成功',
    '日程表':'日程表',
    '生成时间':'生成時間',
    '重新生成日程表':'重新生成日程表',
    '总日程表导出':'總日程表導出',
    '日程明细导出':'日程明細導出',
    '导出':'導出',
    '序号已重复':'序號已重複',
    '分组单位':'分組單位',
    '赛次':'賽次',
    '组数':'組數',
    '人数':'人數',
    '地点':'地點',
    '时间':'時間',
    '重新生成日程表后原数据将清空':'重新生成日程表後原數據將清空',
    '序号不能重复，请检查':'序號不能重複，請檢查',
    '运动员列表':'運動員列表',
    '请选择分组单位':'請選擇分組單位',
    '组别':'組別',
    '请选择组别':'請選擇組別',
    '分组状态':'分組狀態',
    '请选择分组状态':'請選擇分組狀態',
    '已分组':'已分組',
    '未分组':'未分組',
    '请输入运动员姓名或学籍号搜索':'請輸入運動員姓名或學籍號搜索',
    '清空编排':'清空編排',
    '自动分组':'自動分組',
    '取消分组':'取消分組',
    '晋级方式':'晉級方式',
    '跑道编号':'跑道編號',
    '运动员背心编码':'運動員背心編碼',
    '跑道编号':'跑道編號',
    '请选择跑道编号':'請選擇跑道編號',
    '请选择编码':'請選擇編碼',
    '每组人数':'每組人數',
    '请输入每组人数':'請輸入每組人數',
    '每组队伍数':'每組隊伍數',
    '请输入每组队伍数':'請輸入每組隊伍數',
    '是否跨班级':'是否跨班級',
    '是否跨年级':'是否跨年級',
    '区分男女生':'區分男女生',
    '跨分组单位组号重置':'跨分組單位組號重置',
    '最后两组数量均分':'最後兩組數量均分',
    '均分':'均分',
    '不均分':'不均分',
    '生成分组':'生成分組',
    '修改学生编排信息':'修改學生編排信息',
    '组内编号':'組內編號',
    '请选择组内编号':'請選擇組內編號',
    '仅查看未被占用的编号':'僅查看未被佔用的編號',
    '若编号被占用，则编号互换':'若編號被佔用，則編號互換',
    '成员名单':'成員名單',
    '批量导入将清空自动分组数据':'批量導入將清空自動分組數據',
    '运动员姓名':'運動員姓名',
    '运动员编码':'運動員編碼',
    '成员':'成員',
    '设置编排条件':'設置編排條件',
    '轮晋':'輪晉',
    '轮':'輪',
    '前':'前',
    '名':'名',
    '请输入':'請輸入',
    '请选择编排方式':'請選擇編排方式',
    '请选择运动员编码':'請選擇運動員編碼',
    '请选择序号':'請選擇序號',
    '请填写每组人数':'請填寫每組人數',
    '人数不能大于跑道编号！':'人數不能大於跑道編號！',
    '人数不能大于编码数量！':'人數不能大於編碼數量！',
    '请选择跑道':'請選擇跑道',
    '注意：若修改上轮成绩或报名信息，将影响已有的编排，旧的编排数据将被覆盖':'注意：若修改上輪成績或報名信息，將影響已有的編排，舊的編排數據將被覆蓋',
    '注意：分组条件发生了变化，将清空现有编排数据':'注意：分組條件發生了變化，將清空現有編排數據',
    '继续将清除现有数据':'繼續將清除現有數據',
    '确认要清空编排吗？':'確認要清空編排嗎？',
    '确认要取消分组吗？':'確認要取消分組嗎？',
    '报名信息导入完成':'報名信息導入完成',
    '批量报名导入失败列表':'批量報名導入失敗列表',
    '编排信息导入完成':'編排信息導入完成',
    '运动会编排模板':'運動會編排模板',
    '文件':'文件',
    '批量成绩导入失败列表':'批量成績導入失敗列表',
    '成绩导入完成':'成績導入完成',
    '运动会成绩模板':'運動會成績模板',
    '名次':'名次',
    '分值':'分值',
    '破纪录':'破紀錄',
    '若有多轮比赛，仅以决赛成绩为准':'若有多輪比賽，僅以決賽成績為準',
    '一':'一',
    '二':'二',
    '三':'三',
    '四':'四',
    '五':'五',
    '六':'六',
    '七':'七',
    '八':'八',
    '九':'九',
    '十':'十',
    '十一':'十一',
    '十二':'十二',
    '十三':'十三',
    '十四':'十四',
    '十五':'十五',
    '十六':'十六',
    '十七':'十七',
    '十八':'十八',
    '十九':'十九',
    '二十':'二十',
    '明细列表':'明細列表',
    '轮次':'輪次',
    '无效':'無效',
    '有效':'有效',
    '违规':'違規',
    '不违规':'不違規',
    '是否有效':'是否有效',
    '是否违规':'是否違規',
    '班级名称模糊搜索':'班級名稱模糊搜索',
    '姓名，学籍号模糊搜索':'姓名，學籍號模糊搜索',
    '新增记录':'新增記錄',
    '清空数据':'清空數據',
    '团体赛':'團體賽',
    '个人赛':'個人賽',
    '项目类型':'項目類型',
    '记录等级':'記錄等級',
    '校级':'校級',
    '年级':'年級',
    '请选择年级':'請選擇年級',
    '请选择年级班级':'請選擇年級班級',
    '男生':'男生',
    '女生':'女生',
    '记录':'記錄',
    '创造者':'創造者',
    '所属单位':'所屬單位',
    '导入记录':'導入記錄',
    '记录信息导入完成':'記錄信息導入完成',
    '项目不能为空':'項目不能為空',
    '记录等级不能为空':'記錄等級不能為空',
    '性别不能为空':'性別不能為空',
    '记录不能为空':'記錄不能為空',
    '记录填写错误':'記錄填寫錯誤',
    '创造者不能为空':'創造者不能為空',
    '编辑记录':'編輯記錄',
    '新增记录':'新增記錄',
    '是否删除此条记录？':'是否刪除此條記錄？',
    '是否清空记录？':'是否清空記錄？',
    '确认后，数据将不可恢复':'確認後，數據將不可恢復',
    '数据删除成功':'數據刪除成功',
    '编辑记录成功':'編輯記錄成功',
    '新增记录成功':'新增記錄成功',
    '项目奖':'項目獎',
    '积分奖':'積分獎',
    '其他奖项':'其他獎項',
    '电子章管理':'電子章管理',
    '打印':'打印',
    '注意：因模板格式问题，奖状内容部分仅支持1':'注意：因模板格式問題，獎狀內容部分僅支持1-3行，不足或超出時，頁面信息將會錯位，請打印前確認。',
    '注意：因模板格式问题，奖状内容部分仅支持2行，不足或超出时，页面信息将会错位，请打印前确认。':'注意：因模板格式問題，獎狀內容部分僅支持2行，不足或超出時，頁面信息將會錯位，請打印前確認。',
    '注意：仅支持上传PNG格式的图片，比例为：1':'注意：僅支持上傳PNG格式的圖片，比例為：1:1',
    '电子章':'電子章',
    '配置':'配置',
    '奖状主体':'獎狀主體',
    '获奖主体':'獲獎主體',
    '请输入获奖主体':'請輸入獲獎主體',
    '运动会名称':'運動會名稱',
    '请输入运动会名称':'請輸入運動會名稱',
    '比赛轮次':'比賽輪次',
    '请选择比赛轮次':'請選擇比賽輪次',
    '奖项名称':'獎項名稱',
    '请选择奖项名称':'請選擇獎項名稱',
    '获奖内容':'獲獎內容',
    '请输入获奖内容':'請輸入獲獎內容',
    '请输入奖项名称':'請輸入獎項名稱',
    '获奖名次':'獲獎名次',
    '请选择获奖名次':'請選擇獲獎名次',
    '颁奖机构':'頒獎機構',
    '请输入颁奖机构':'請輸入頒獎機構',
    '颁奖日期':'頒獎日期',
    '请选择颁奖日期':'請選擇頒獎日期',
    '请选择电子章':'請選擇電子章',
    '生成奖状':'生成獎狀',
    '新增电子章':'新增電子章',
    '名称':'名稱',
    '请输入电子章名称':'請輸入電子章名稱',
    '点击上传图片':'點擊上傳圖片',
    '支持上传比1':'支持上傳比1:1比例的PNG圖片，2M以內',
    '请选择项目名称':'請選擇項目名稱',
    '请上传对应的电子章':'請上傳對應的電子章',
    '请选择奖状主体':'請選擇獎狀主體',
    '请输入颁奖日期':'請輸入頒獎日期',
    '个人积分':'個人積分',
    '班级积分':'班級積分',
    '请上传图片':'請上傳圖片',
    '电子章最多10个':'電子章最多10個',
    '只能导入格式为png格式的文件！':'只能導入格式為png格式的文件！',
    '图片已损坏':'圖片已損壞',
    '是否需要删除选中的电子章？':'是否需要刪除選中的電子章？',
    '请选择需要删除的电子章':'請選擇需要刪除的電子章',
    '积分列表':'積分列表',
    '规则说明':'規則說明',
    '积分规则配置':'積分規則配置',
    '生成积分':'生成積分',
    '上次生成时间':'上次生成時間',
    '修改':'修改',
    '积分记录':'積分記錄',
    '1、成绩相同则名次相同，如：第1名和第2名成绩相同，将会产生两个第1名，后续名次为第3名。以此类推。':'1、成績相同則名次相同，如：第1名和第2名成績相同，將會產生兩個第1名，後續名次為第3名。以此類推。',
    '2、若同时有多个相同名次，则每位运动员获得的积分计算公式为：相同名次运动员所占用名次的积分之和':'2、若同時有多個相同名次，則每位運動員獲得的積分計算公式為：相同名次運動員所佔用名次的積分之和/運動員數量，得出每位運動員積分值，如：第1名加10分，第二名加8分，若有兩個第1名，則每位運動員增加的積分為：（10+8）/2=9分，以此類推。',
    '积分修改':'積分修改',
    '加减分数':'加減分數',
    '积分':'積分',
    '积分来源':'積分來源',
    '确认要重新生成积分吗？':'確認要重新生成積分嗎？',
    '继续将清除现有积分数据':'繼續將清除現有積分數據',
    '积分修改成功':'積分修改成功',
    '分数不能为空':'分數不能為空',
    '备注不能为空':'備註不能為空',
    '加减分数最高只能为':'加減分數最高只能為',
    '加减分数最低只能为':'加減分數最低只能為',
    '详情':'詳情',
    '报名':'報名',
    '编排':'編排',
    '记录管理':'記錄管理',
    '明细':'明細',
    '证书':'證書',
    '项目列表':'項目列表',
    '查看日程表':'查看日程表',
    '项目配置':'項目配置',
    '赛制':'賽制',
    '比赛方式':'比賽方式',
    '请选择该项目的比赛轮次，如预赛、决赛则选择2':'請選擇該項目的比賽輪次，如預賽、決賽則選擇2',
    '最多四个字':'最多四個字',
    '排名赛':'排名賽',
    '团队赛':'團隊賽',
    '田赛':'田賽',
    '径赛':'徑賽',
    '组内':'組內',
    '本轮参赛者':'本輪參賽者',
    '请选择赛制':'請選擇賽制',
    '请选择比赛方式':'請選擇比賽方式',
    '该填写完整':'該填寫完整',
    '无编排数据！':'無編排數據！',
    '附标题':'副標題',
    '请输入附标题':'請輸入副標題',
    '请上传比例为1':'請上傳比例為1:1且小於5M的PNG、JPG格式圖片',
    '报名时间':'報名時間',
    '比赛时间':'比賽時間',
    '赛事文件':'賽事文件',
    '正在上传':'正在上傳',
    '上传文件':'上傳文件',
    '未上传文件':'未上傳文件',
    '50M以内；支持扩展名：':'50M以內；支持擴展名：.xlsx、.docx、.pdf',
    '每人限报数量':'每人限報數量',
    '修改后不影响已经报名的数据':'修改後不影響已經報名的數據',
    '范围':'範圍',
    '班级报名人数':'班級報名人數',
    '为空时，不限制人数':'為空時，不限制人數',
    '队伍人数':'隊伍人數',
    '请输入标题':'請輸入標題',
    '请选择报名时间':'請選擇報名時間',
    '请选择开始时间':'請選擇開始時間',
    '请选择结束时间':'請選擇結束時間',
    '请选择比赛时间':'請選擇比賽時間',
    '比赛时间不得早于报名结束时间':'比賽時間不得早於報名結束時間',
    '请选择':'請選擇',
    '跑道':'跑道',
    '运动员成绩批量导出':'運動員成績批量導出',
    '运动会列表':'運動會列表',
    '请输入运动会名称关键字':'請輸入運動會名稱關鍵字',
    '新增运动会':'新增運動會',
    '运动风采':'運動風采',
    '确认要删除该运动会：{name}':'確認要刪除該運動會：{name}嗎？',
    '删除后将无法查看本运动会数据':'刪除後將無法查看本運動會數據',
    '确认要提前结束该运动会：':'確認要提前結束該運動會：',
    '确认要提前结束该运动会：{name}':'確認要提前結束該運動會：{name}嗎？',
    '运动会结束后不再支持学生运动':'運動會結束後不再支援學生運動',
    '运动风采展示':'運動風采展示',
    '全部选中':'全部選中',
    '运动风采':'運動風采',
    '照片上传':'照片上傳',
    '只能导入格式为png、jpg、jpeg格式的文件，单张照片大小不超过20M，历史导入最多不超过100张。':'只能導入格式為png、jpg、jpeg格式的文件，單張照片大小不超過20M，歷史導入最多不超過100張。',
    '上传成功数量：':'上傳成功數量：',
    '上传失败数量：':'上傳失敗數量：',
    '正在加载压缩文件':'正在加載壓縮文件',
    '风采':'風采',
    '正在压缩':'正在壓縮',
    '压缩完成':'壓縮完成',
    '文件压缩失败':'文件壓縮失敗',
    '是否需要删除选中的图片？':'是否需要刪除選中的圖片？',
    '请选择需要删除的运动风采':'請選擇需要刪除的運動風采',
    '导入失败，每个运动会最多支持100张图片！':'導入失敗，每個運動會最多支持100張圖片！',
    '部分导入成功':'部分導入成功',
    '导入失败':'導入失敗',
    '导入成功':'導入成功',
    '图片已损坏':'圖片已損壞',
    '编排方式':'編排方式',
    '跑道数量':'跑道數量',
    '请选择跑道数量':'請選擇跑道數量',
    '编码':'編碼',
    '重新分组将覆盖原有分组数据，是否重新分组？':'重新分組將覆蓋原有分組數據，是否重新分組？',
    '确认要取消编排吗？':'確認要取消編排嗎？',
    '姓名、学籍号、编号模糊搜索':'姓名、學籍號、編號模糊搜索',
    '运动会报名导入模板':'運動會報名導入模板',
    '运动员编号':'運動員編號',
    '参赛项目':'參賽項目',
    '确认移除 {name}的报名信息吗':'確認移除 {name}的報名信息嗎？',
    '该编号已经被使用':'該編號已經被使用',
    '删除运动员':'刪除運動員',
    '请选择运动员':'請選擇運動員',
    '添加项目':'添加項目',
    '请选择运动会时间':'請選擇運動會時間',
    '项目已有编排或报名数据，请清除相应数据后再移除。':'項目已有編排或報名數據，請清除相應數據後再移除。',
    '请勿重复选择相同项目。':'請勿重複選擇相同項目。',
    '最佳成绩':'最佳成績',

    // 2026.5.22
    '取消将清空表单内容':'取消將清空表單內容',
    '基本信息':'基本資訊',
    '副标题':'副標題',
    '计分方式':'計分方式',
    '班级集体赛':'班級集體賽',
    '班级团队赛':'班級團隊賽',
    '参赛班级':'參賽班級',
    '班级参赛人数':'班級參賽人數',
    '运动员已有成绩上报不可移除':'運動員已有成績上報不可移除',
    '是否移除该运动员':'是否移除該運動員？',
    '移除后将同步清除该运动员编排信息其他编排数据不变':'移除後將同步清除該運動員編排資訊，其他編排數據不變',
    '新增报名':'新增報名',
    '输入完整学籍号搜索':'輸入完整學籍號搜尋',
    '班级个人汇总':'班級個人彙總',
    '班级个人最佳':'班級個人最佳',
    '班级个人平均':'班級個人平均',
    '请选择计分方式':'請選擇計分方式',
    '运动强度':'運動強度',
    '选择项目':'選擇項目',
    '运动方式':'運動方式',
    '强度':'強度',
    '不限制':'不限制',
    '学籍号不能为空':'學籍號不能為空',
    '同班同组':'同班同組',
    '已存在编排数据请清空后导入':'已存在編排數據，請清空後匯入',
    '导出全量数据':'匯出全量數據',
    '运动会明细总表':'運動會明細總表',
    '作废':'作廢',
    '取消作废':'取消作廢',
    '是否取消作废该记录':'是否取消作廢該記錄？',
    '是否作废该记录':'是否作廢該記錄？',
    '取消后该成绩将置为有效':'取消後，該成績將置為有效',
    '作废后成绩将置为无效':'作廢後成績將置為無效',
    '是否取消':'是否取消？',
    '编号':'編號',
    '未搜索到运动员':'未搜索到運動員',

    // 2026.6.24
    '编排条件设置':'編排條件設定',
    '注意请确认当前编排的轮次是否正确':'注意：請確認當前編排的輪次是否正確',
    '分组规模':'分組規模',
    '背心号码':'背心號碼',
    '道次':'道次',
    '分组单位生成规则':'分組單位生成規則',
    '运动员仅在同一分组单位内排名不跨分组单位比较':'運動員僅在同一分組單位內排名，不跨分組單位比較',
    '分组规则':'分組規則',
    '性别':'性別',
    '区分男女':'區分男女',
    '男女混合':'男女混合',
    '评比范围':'評比範圍',
    '组号':'組號',
    '按分组单位重新编号':'按分組單位重新編號',
    '连续编号':'連續編號',
    '末组均分':'末組均分',
    '最后两组人数均分':'最後兩組人數均分',
    '组内运动员分配':'組內運動員分配',
    '班级内评比':'班級內評比',
    '年级内评比':'年級內評比',
    '全校评比':'全校評比',
    '仅同班同组':'僅同班同組',
    '优先同班同组':'優先同班同組',
    '仅同班不同组':'僅同班不同組',
    '优先同班不同组':'優先同班不同組',
    '随机分配':'隨機分配',
    '成绩优异者居中':'成績優異者居中',
    '道次分配':'道次分配',
    '背心号码分配':'背心號碼分配',
    '序号分配':'序號分配',
}